module.exports = __webpack_public_path__ + "img/QuestionMark.08ab05b4.png";